import { useEffect, useState } from 'react'

import { CustomerApi } from '../api'
import { captureException } from '../utils/sentry'

import { getInitialIntegrationSettings } from './useFormValues'

type setter = (field: string, value: any, shouldValidate?: boolean) => void

export default function useIntegrations(setFieldValue?: setter) {
  const [loadingIntegrations, setLoadingIntegrations] = useState(false)
  const [integrations, setIntegrations] = useState([])
  const [integrationsFailed, setIntegrationsFailed] = useState(false)

  const fetchIntegrations = () => {
    setLoadingIntegrations(true)
    setIntegrationsFailed(false)

    CustomerApi.get('/integrations/admin/notification/error')
      .then(({ data }: any) => {
        setIntegrations(data)
      })
      .catch((error: any) => {
        setIntegrationsFailed(true)
        captureException(error, { tags: { location: 'fetchIntegrations-notificationSettings' } })
      })
      .finally(() => {
        setLoadingIntegrations(false)
      })
  }

  useEffect(() => {
    fetchIntegrations()
  }, [])

  useEffect(() => {
    if (setFieldValue) {
      const initialIntegrationSettings = getInitialIntegrationSettings(integrations)
      setFieldValue('integrationSettings', initialIntegrationSettings)
    }
  }, [integrations, setFieldValue])

  return { loadingIntegrations, integrations, integrationsFailed, fetchIntegrations }
}
